import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { Page, LayoutSingleColumn, Footer } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import facebookImage from '../../assets/vivianlab-brandImage.png';
import twitterImage from '../../assets/vivianlab-brandImage.png';
import { withViewport } from '../../util/uiHelpers';
import { useConfiguration } from '../../context/configurationContext';
import css from './ContactPage.module.css';
import ContactForm from './ContactForm/ContactForm';
import { isLocaleGreek } from '../../util/genericHelpers';
import SectionHero from './SectionHero';
import { sendNotification } from '../DoctorOnboardingPage/DoctorOnboardingPage.duck';
import { SendGridTemplateIds } from '../../helpers/enums';
import { trackAContactUsClicked } from '../../util/mixpanelHelpers';
import { MIXPANEL_EVENTS } from '../../util/enums';
export const ContactPageComponent = props => {
  const { intl, scrollingDisabled, onSendNotification } = props;
  const config = useConfiguration();
  const [isLoading, setLoading] = useState(false);
  const [ready, setReady] = useState(false);
  const siteTitle = config.marketplaceName;
  const schemaTitle = intl.formatMessage({ id: 'ContactPage.schemaTitle' }, { siteTitle });
  const schemaDescription = intl.formatMessage({
    id: 'ContactPage.schemaDescription',
  });
  const schemaImage = `${config.marketplaceRootURL}${facebookImage}`;
  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      facebookImages={[{ url: facebookImage, width: 1200, height: 630 }]}
      twitterImages={[
        {
          url: `${config.marketplaceRootURL}${twitterImage}`,
          width: 600,
          height: 314,
        },
      ]}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
    >
      <LayoutSingleColumn
        isStaticPage={true}
        className={css.pageRoot}
        topbar={<TopbarContainer isFullWidthHeader isPostLandingPage />}
        footer={<Footer />}
      >
        <div className={css.pageContent}>
          <SectionHero />
          <ContactForm
            inProgress={isLoading}
            ready={ready}
            onSubmit={async values => {
              setLoading(true);

              trackAContactUsClicked(MIXPANEL_EVENTS?.CONTACT_SUBMITTED);
              try {
                const emailResponse = await onSendNotification({
                  templateId: SendGridTemplateIds.CONTACT_US,
                  // recipients: ['vishalsingh17466@gmail.com'],
                  recipients: ['info@vivianlab.com'],
                  dynamicData: {
                    userName: values?.firstName + ' ' + values?.lastName,
                    email: values?.email,
                    content: values?.message,
                    phone: values?.phoneNumber,
                  },
                });
                setLoading(false);
                setReady(true);
              } catch {
                setLoading(false);
              }
            }}
            isGreek={isLocaleGreek()}
          />
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};
const { bool, object } = PropTypes;
ContactPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  // from injectIntl
  intl: intlShape.isRequired,
};
const mapStateToProps = state => {
  const { currentUser } = state.user;
  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
  };
};
const mapDispatchToProps = dispatch => ({
  onSendNotification: params => dispatch(sendNotification(params)),
});
const ContactPage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withViewport,
  injectIntl
)(ContactPageComponent);
export default ContactPage;
